import { useTranslation } from 'react-i18next'
import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'

type StandardsLibraryPrimaryButtonsProps = {
  onAddStandard: () => void
}

export function StandardsLibraryPrimaryButtons({
  onAddStandard,
}: StandardsLibraryPrimaryButtonsProps) {
  const { t } = useTranslation('standardsLibrary')
  return (
    <div className='flex gap-2'>
      <Button className='gap-2' onClick={onAddStandard}>
        <Plus className='size-4' />
        <span>{t('addStandard')}</span>
      </Button>
    </div>
  )
}
